const getConfig = require("next/config").default;

const {
  getShouldDeliveryDealerBeIncluded,
} = require("@shared/v2/lib/getShouldDeliveryDealerBeIncluded");

const { publicRuntimeConfig } = getConfig();
const { COUNTRY } = publicRuntimeConfig;

export const useGetShouldDeliveryDealerBeIncluded = () => {
  return getShouldDeliveryDealerBeIncluded(COUNTRY);
};
